import { render, staticRenderFns } from "./goodAttrAdd.vue?vue&type=template&id=3e4b7dab&scoped=true"
import script from "./goodAttrAdd.vue?vue&type=script&lang=js"
export * from "./goodAttrAdd.vue?vue&type=script&lang=js"
import style0 from "./goodAttrAdd.vue?vue&type=style&index=0&id=3e4b7dab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4b7dab",
  null
  
)

export default component.exports